export default "__VITE_ASSET__01b7e505__"